import { jwtDecode as c } from "jwt-decode";
const o = (e) => {
  try {
    return e ? c(e) : null;
  } catch {
    return null;
  }
}, i = (e, r = 30) => {
  var n;
  const t = (n = o(e)) == null ? void 0 : n.exp;
  return !Number.isFinite(t) || t <= Date.now() / 1e3 + r;
}, a = (e, r) => {
  if (!e || !r) return !1;
  if (e === r) return !0;
  const t = o(e), n = o(r);
  return !!(t != null && t.accountID) && !!t.rtSign && t.accountID === (n == null ? void 0 : n.accountID) && t.rtSign === (n == null ? void 0 : n.rtSign);
};
export {
  o as readToken,
  a as sameTokenSession,
  i as tokenExpired
};
//# sourceMappingURL=token.js.map
